<template>
  <header class="site-header sticky-top">
    <b-navbar toggleable="lg" class="py-3 px-0">
      <div class="container">
        <b-navbar-brand :to="{ name: 'home' }" tag="router-link" class="d-flex align-items-center brand-link">
          <img src="../assets/logo.svg" alt="Nihon Water Maintenance" class="brand-logo">
          <div>
            <div class="brand-name">{{ companyInfo.companyName || "Công ty TNHH NWM Việt Nam" }}</div>
            <div class="brand-tagline">Cleaner Water, Bluer Future</div>
          </div>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse" />

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto align-items-lg-center">
            <b-nav-item :to="{ name: 'home' }" tag="router-link">Trang chủ</b-nav-item>
            <b-nav-item :to="{ name: 'about' }" tag="router-link">Giới thiệu</b-nav-item>
            <b-nav-item :to="{ name: 'news' }" tag="router-link">Tin tức</b-nav-item>
            <b-nav-item :to="{ name: 'contact' }" tag="router-link">Liên hệ</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
  </header>
</template>

<script>
export default {
  name: "SiteHeader",
  props: {
    companyInfo: {
      type: Object,
      default: function defaultCompanyInfo() {
        return {};
      }
    }
  }
};
</script>

<style scoped>
.site-header {
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(0, 61, 153, 0.08);
  box-shadow: 0 8px 28px rgba(10, 31, 68, 0.06);
  backdrop-filter: blur(16px);
  z-index: 10;
}

.brand-link {
  gap: 12px;
}

.brand-logo {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 6px 18px rgba(0, 61, 153, 0.16);
}

.brand-name {
  font-weight: 800;
  color: var(--water-blue);
  line-height: 1.2;
}

.brand-tagline {
  font-size: 13px;
  color: var(--soft-text);
  margin-top: 3px;
}

.site-header >>> .navbar-nav .nav-link {
  color: var(--soft-text);
  font-weight: 600;
  padding: 10px 14px;
  border-radius: 999px;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.site-header >>> .navbar-nav .nav-link:hover,
.site-header >>> .navbar-nav .nav-link.router-link-exact-active {
  color: var(--water-blue);
  background: rgba(0, 191, 255, 0.1);
}

.site-header >>> .navbar-toggler {
  border-color: rgba(0, 61, 153, 0.16);
  border-radius: 10px;
}

@media (max-width: 991px) {
  .site-header >>> .navbar-nav {
    padding-top: 12px;
  }

  .site-header >>> .navbar-nav .nav-link {
    border-radius: 10px;
  }
}

</style>
